import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export function ModalPortal({ children }) {
  return ReactDOM.createPortal(
    <>
      {children}
      <div className="modal-backdrop fade show" />
    </>,
    document.getElementById('modal-root')
  );
}

ModalPortal.propTypes = {
  children: PropTypes.node.isRequired
};

export default ModalPortal;
